module.exports = __webpack_public_path__ + "img/TH_flag.cc8a4c44.svg";